import { Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { Observable, of, Subject } from 'rxjs';
import { shareReplay, switchMap, take, takeUntil } from 'rxjs/operators';
import { User } from '../models/User';
import { UserService } from '../services/user.service';

@Component({
	selector: 'app-teacher-pin',
	templateUrl: './teacher-pin.component.html',
	styleUrls: ['./teacher-pin.component.scss'],
})
export class TeacherPinComponent implements OnInit, OnDestroy {
	form: UntypedFormGroup;
	user$: Observable<User>;
	userPin$: Observable<string | number> = this.userService.getUserPin().pipe(
		shareReplay({
			bufferSize: 1,
			refCount: true,
		})
	);
	destroy$ = new Subject<void>();

	constructor(private userService: UserService, private dialogRef: MatDialogRef<TeacherPinComponent>) {}

	get pinData$() {
		return this.userPin$.pipe(
			take(1),
			switchMap((pin) => {
				if (pin !== this.form.get('pin').value && this.form.get('pin').dirty) {
					return of(this.form.value);
				} else {
					return of(null);
				}
			})
		);
	}

	ngOnInit() {
		this.user$ = this.userService.userJSON$;
		this.userPin$.pipe(takeUntil(this.destroy$)).subscribe((res) => {
			this.form = new UntypedFormGroup({
				pin: new UntypedFormControl(res || '', [
					Validators.required,
					Validators.minLength(4),
					Validators.pattern('^[0-9]*?[0-9]+$'),
					(fn) => (fn.value.length < 4 ? { minPin: true } : null),
				]),
			});
		});
	}

	save() {
		this.user$
			.pipe(
				take(1),
				switchMap((user) => {
					return this.userService.updateUserRequest(user, this.form.value);
				})
			)
			.subscribe(() => {
				this.close();
			});
	}

	close() {
		this.dialogRef.close();
	}

	ngOnDestroy() {
		this.destroy$.next();
		this.destroy$.complete();
	}
}
